import { Children } from '@/utils/reactTypes';

// If you want to indicate to the browser a “preferred” place to wrap text,
//  you can wrap both sides of that place with this element.
export const PreferNoWrap = ({ children }: { children: Children }) => (
    <span style={{ display: 'inline-block' }}>{children}</span>
);

// If you don’t want some text to be wrapped, then wrap it with this component.
export const NoWrap = ({ children }: { children: Children }) => (
    <span style={{ whiteSpace: 'nowrap' }}>{children}</span>
);
